var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-select-user"},[(_vm.value)?_c('strong',{staticStyle:{"margin-right":"6px"}},[_vm._v(_vm._s(_vm.value))]):_vm._e(),_c('el-button',{attrs:{"type":"default","plain":"","icon":"el-icon-search","size":"mini"},on:{"click":_vm.beginSelectUser}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }